/* PPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPP
   VIRTUAL TRY-ON FEATURE
   PPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPP */

class VirtualTryOn {
  constructor() {
    this.config = window.edTryOnConfig || {};
    this.DAILY_LIMIT = this.config.dailyLimit || 5;
    this.STORAGE_KEY = this.config.storageKey || 'ed_try_on_data';
    this.API_URL = this.config.apiUrl || '';

    // DOM Elements
    this.trigger = document.getElementById('ed-try-on-trigger');
    this.overlay = document.getElementById('ed-try-on-overlay');
    this.modal = this.overlay?.querySelector('.ed-try-on-modal');
    this.closeBtn = document.getElementById('ed-try-on-close');
    this.fileInput = document.getElementById('ed-try-on-file-input');
    this.dropzone = document.getElementById('ed-try-on-dropzone');
    this.dropzoneContent = document.getElementById('ed-try-on-dropzone-content');
    this.preview = document.getElementById('ed-try-on-preview');
    this.previewImage = document.getElementById('ed-try-on-preview-image');
    this.previewRemove = document.getElementById('ed-try-on-preview-remove');
    this.generateBtn = document.getElementById('ed-try-on-generate');
    this.limitCounter = document.getElementById('ed-try-on-limit');
    this.remainingSpan = document.getElementById('ed-try-on-remaining');
    this.limitReached = document.getElementById('ed-try-on-limit-reached');
    this.timerSpan = document.getElementById('ed-try-on-timer');
    this.content = document.getElementById('ed-try-on-content');
    this.result = document.getElementById('ed-try-on-result');
    this.resultImage = document.getElementById('ed-try-on-result-image');
    this.backBtn = document.getElementById('ed-try-on-back');
    this.errorContainer = document.getElementById('ed-try-on-error');
    this.errorText = document.getElementById('ed-try-on-error-text');

    // Progress Elements
    this.progress = document.getElementById('ed-try-on-progress');
    this.progressBar = document.getElementById('ed-try-on-progress-bar');
    this.progressPercent = document.getElementById('ed-try-on-progress-percent');
    this.progressStatus = document.getElementById('ed-try-on-progress-status');

    // State
    this.selectedFile = null;
    this.timerInterval = null;
    this.progressInterval = null;

    // Initialize if elements exist
    if (this.trigger && this.overlay) {
      this.init();
    }
  }

  init() {
    this.bindEvents();
    this.updateLimitDisplay();
  }

  bindEvents() {
    // Open modal
    this.trigger.addEventListener('click', () => this.open());

    // Close modal
    this.closeBtn?.addEventListener('click', () => this.close());
    this.overlay?.addEventListener('click', (e) => {
      if (e.target === this.overlay) this.close();
    });

    // Escape key to close
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.overlay?.classList.contains('is-active')) {
        this.close();
      }
    });

    // File input change
    this.fileInput?.addEventListener('change', (e) => {
      if (e.target.files && e.target.files[0]) {
        this.handleFile(e.target.files[0]);
      }
    });

    // Drag and drop
    if (this.dropzone) {
      this.dropzone.addEventListener('dragover', (e) => {
        e.preventDefault();
        this.dropzone.classList.add('is-dragover');
      });

      this.dropzone.addEventListener('dragleave', () => {
        this.dropzone.classList.remove('is-dragover');
      });

      this.dropzone.addEventListener('drop', (e) => {
        e.preventDefault();
        this.dropzone.classList.remove('is-dragover');
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
          this.handleFile(e.dataTransfer.files[0]);
        }
      });
    }

    // Remove preview
    this.previewRemove?.addEventListener('click', (e) => {
      e.stopPropagation();
      this.clearPreview();
    });

    // Generate button
    this.generateBtn?.addEventListener('click', () => this.generate());

    // Back button
    this.backBtn?.addEventListener('click', () => this.showUploadView());
  }

  // PPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPP
  // Rate Limiting (LocalStorage mit 24h Reset)
  // PPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPP

  getLimitData() {
    try {
      const data = JSON.parse(localStorage.getItem(this.STORAGE_KEY) || '{}');
      const now = Date.now();

      // Reset wenn 24h abgelaufen
      if (!data.resetTime || now >= data.resetTime) {
        const newData = {
          count: 0,
          resetTime: now + (24 * 60 * 60 * 1000) // 24 Stunden
        };
        try {
          localStorage.setItem(this.STORAGE_KEY, JSON.stringify(newData));
        } catch (storageErr) {
          // LocalStorage voll - versuche alten Eintrag zu löschen
          try {
            localStorage.removeItem(this.STORAGE_KEY);
            localStorage.setItem(this.STORAGE_KEY, JSON.stringify(newData));
          } catch (e) {
            // Ignorieren wenn Storage nicht funktioniert
          }
        }
        return newData;
      }

      return data;
    } catch (e) {
      console.error('LocalStorage Fehler:', e);
      return { count: 0, resetTime: Date.now() + (24 * 60 * 60 * 1000) };
    }
  }

  getRemainingTries() {
    const data = this.getLimitData();
    return Math.max(0, this.DAILY_LIMIT - data.count);
  }

  incrementUsage() {
    try {
      // Direkt aus localStorage lesen um sicherzustellen, dass wir den aktuellen Wert haben
      const stored = localStorage.getItem(this.STORAGE_KEY);
      const data = stored ? JSON.parse(stored) : { count: 0, resetTime: Date.now() + (24 * 60 * 60 * 1000) };

      // Nur inkrementieren wenn resetTime noch nicht abgelaufen
      const now = Date.now();
      if (data.resetTime && now < data.resetTime) {
        data.count = (data.count || 0) + 1;
      } else {
        // Reset und dann auf 1 setzen
        data.count = 1;
        data.resetTime = now + (24 * 60 * 60 * 1000);
      }

      localStorage.setItem(this.STORAGE_KEY, JSON.stringify(data));
      console.log('Try-On Usage incremented:', data);
    } catch (e) {
      console.error('LocalStorage Fehler beim Inkrementieren:', e);
    }
  }

  updateLimitDisplay() {
    const remaining = this.getRemainingTries();
    const data = this.getLimitData();

    console.log('updateLimitDisplay - remaining:', remaining, 'data:', data);

    if (this.remainingSpan) {
      this.remainingSpan.textContent = remaining;
      console.log('Updated remainingSpan to:', remaining);
    } else {
      console.warn('remainingSpan element not found!');
    }

    if (remaining <= 0) {
      this.showLimitReached(data.resetTime);
    } else {
      this.hideLimitReached();
    }
  }

  showLimitReached(resetTime) {
    if (this.limitCounter) this.limitCounter.style.display = 'none';
    if (this.content) this.content.style.display = 'none';
    if (this.limitReached) this.limitReached.style.display = 'block';

    this.startTimer(resetTime);
  }

  hideLimitReached() {
    if (this.limitCounter) this.limitCounter.style.display = 'flex';
    if (this.content) this.content.style.display = 'flex';
    if (this.limitReached) this.limitReached.style.display = 'none';

    this.stopTimer();
  }

  startTimer(resetTime) {
    this.stopTimer();

    const updateTimer = () => {
      const now = Date.now();
      const diff = resetTime - now;

      if (diff <= 0) {
        this.stopTimer();
        this.updateLimitDisplay();
        return;
      }

      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      if (this.timerSpan) {
        this.timerSpan.textContent =
          `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
      }
    };

    updateTimer();
    this.timerInterval = setInterval(updateTimer, 1000);
  }

  stopTimer() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
    }
  }

  // PPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPP
  // Modal Open/Close
  // PPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPP

  open() {
    this.updateLimitDisplay();
    this.hideError();
    this.showUploadView();

    document.body.classList.add('ed-try-on-open');
    this.overlay.classList.add('is-active');
    this.overlay.setAttribute('aria-hidden', 'false');

    // Trap focus in modal
    this.closeBtn?.focus();
  }

  close() {
    document.body.classList.remove('ed-try-on-open');
    this.overlay.classList.remove('is-active');
    this.overlay.setAttribute('aria-hidden', 'true');

    this.stopTimer();
    this.clearPreview();

    // Return focus to trigger
    this.trigger?.focus();
  }

  // PPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPP
  // File Handling
  // PPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPP

  handleFile(file) {
    // Validate file type
    const validTypes = ['image/jpeg', 'image/png', 'image/webp', 'image/gif'];
    if (!validTypes.includes(file.type)) {
      this.showError('Bitte w�hle ein Bild im Format JPEG, PNG, WebP oder GIF.');
      return;
    }

    // Validate file size (max 10MB)
    if (file.size > 10 * 1024 * 1024) {
      this.showError('Das Bild ist zu gro�. Maximal 10MB erlaubt.');
      return;
    }

    this.selectedFile = file;
    this.hideError();

    // Show preview
    const reader = new FileReader();
    reader.onload = (e) => {
      if (this.previewImage) {
        this.previewImage.src = e.target.result;
      }
      if (this.preview) {
        this.preview.style.display = 'block';
      }
      if (this.dropzoneContent) {
        this.dropzoneContent.style.display = 'none';
      }
      if (this.generateBtn) {
        this.generateBtn.disabled = false;
      }
    };
    reader.readAsDataURL(file);
  }

  clearPreview() {
    this.selectedFile = null;

    if (this.preview) {
      this.preview.style.display = 'none';
    }
    if (this.previewImage) {
      this.previewImage.src = '';
    }
    if (this.dropzoneContent) {
      this.dropzoneContent.style.display = 'flex';
    }
    if (this.generateBtn) {
      this.generateBtn.disabled = true;
    }
    if (this.fileInput) {
      this.fileInput.value = '';
    }
  }

  // PPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPP
  // View Switching
  // PPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPP

  showUploadView() {
    if (this.content) this.content.style.display = 'flex';
    if (this.result) this.result.style.display = 'none';
    if (this.progress) this.progress.style.display = 'none';
    this.clearPreview();
    this.updateLimitDisplay();
    this.stopProgress();
  }

  showProgressView() {
    if (this.content) this.content.style.display = 'none';
    if (this.limitCounter) this.limitCounter.style.display = 'none';
    if (this.result) this.result.style.display = 'none';
    if (this.progress) this.progress.style.display = 'block';

    // Reset progress
    this.updateProgress(0, 'Bilder werden analysiert...');
  }

  showResultView(imageData, mimeType) {
    if (this.content) this.content.style.display = 'none';
    if (this.limitCounter) this.limitCounter.style.display = 'none';
    if (this.progress) this.progress.style.display = 'none';
    if (this.result) this.result.style.display = 'block';

    if (this.resultImage) {
      this.resultImage.src = `data:${mimeType};base64,${imageData}`;
    }
  }

  // PPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPP
  // Progress Animation
  // PPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPP

  updateProgress(percent, status) {
    if (this.progressPercent) {
      this.progressPercent.textContent = Math.round(percent);
    }

    if (this.progressBar) {
      // Circle circumference = 2 * PI * r = 2 * 3.14159 * 45 ≈ 283
      const circumference = 283;
      const offset = circumference - (percent / 100) * circumference;
      this.progressBar.style.strokeDashoffset = offset;
    }

    if (this.progressStatus && status) {
      this.progressStatus.textContent = status;
    }
  }

  startProgress() {
    this.stopProgress();

    let currentProgress = 0;
    const stages = [
      { target: 15, status: 'Bilder werden analysiert...', duration: 2000 },
      { target: 35, status: 'Körpermerkmale werden erkannt...', duration: 3000 },
      { target: 55, status: 'Kleidungsstück wird angepasst...', duration: 4000 },
      { target: 75, status: 'Bild wird generiert...', duration: 5000 },
      { target: 90, status: 'Feinschliff wird angewendet...', duration: 8000 }
    ];

    let stageIndex = 0;
    let stageStartTime = Date.now();
    let stageStartProgress = 0;

    const animate = () => {
      if (stageIndex >= stages.length) {
        return;
      }

      const stage = stages[stageIndex];
      const elapsed = Date.now() - stageStartTime;
      const stageProgress = Math.min(elapsed / stage.duration, 1);
      const progressRange = stage.target - stageStartProgress;

      currentProgress = stageStartProgress + (progressRange * this.easeOutQuad(stageProgress));

      this.updateProgress(currentProgress, stage.status);

      if (stageProgress >= 1) {
        stageIndex++;
        if (stageIndex < stages.length) {
          stageStartTime = Date.now();
          stageStartProgress = stage.target;
        }
      }

      if (stageIndex < stages.length) {
        this.progressInterval = requestAnimationFrame(animate);
      }
    };

    this.progressInterval = requestAnimationFrame(animate);
  }

  stopProgress() {
    if (this.progressInterval) {
      cancelAnimationFrame(this.progressInterval);
      this.progressInterval = null;
    }
  }

  completeProgress() {
    this.stopProgress();
    this.updateProgress(100, 'Fertig!');
  }

  easeOutQuad(t) {
    return t * (2 - t);
  }

  // PPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPP
  // API Call
  // PPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPP

  async generate() {
    if (!this.selectedFile || this.getRemainingTries() <= 0) {
      return;
    }

    this.hideError();
    this.showProgressView();
    this.startProgress();

    try {
      const formData = new FormData();
      formData.append('customerImage', this.selectedFile);
      formData.append('productImageUrl', this.config.productImageUrl);

      const response = await fetch(this.API_URL, {
        method: 'POST',
        body: formData
      });

      const data = await response.json();

      if (!response.ok || !data.success) {
        throw new Error(data.error || 'Ein Fehler ist aufgetreten');
      }

      // Success - complete progress animation then show result
      this.completeProgress();

      // Short delay to show 100% before switching to result
      await new Promise(resolve => setTimeout(resolve, 500));

      this.incrementUsage();
      this.updateLimitDisplay();
      this.showResultView(data.image, data.mimeType || 'image/png');

    } catch (error) {
      console.error('Try-On Fehler:', error);
      this.stopProgress();
      this.showUploadView();
      this.showError(error.message || 'Die Bildgenerierung ist fehlgeschlagen. Bitte versuche es erneut.');
    }
  }

  setLoading(isLoading) {
    if (!this.generateBtn) return;

    const textSpan = this.generateBtn.querySelector('.ed-try-on-generate-text');
    const loadingSpan = this.generateBtn.querySelector('.ed-try-on-generate-loading');

    if (isLoading) {
      this.generateBtn.classList.add('is-loading');
      this.generateBtn.disabled = true;
      if (textSpan) textSpan.style.display = 'none';
      if (loadingSpan) loadingSpan.style.display = 'flex';
    } else {
      this.generateBtn.classList.remove('is-loading');
      this.generateBtn.disabled = !this.selectedFile;
      if (textSpan) textSpan.style.display = 'inline';
      if (loadingSpan) loadingSpan.style.display = 'none';
    }
  }

  // PPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPP
  // Error Handling
  // PPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPP

  showError(message) {
    if (this.errorContainer && this.errorText) {
      this.errorText.textContent = message;
      this.errorContainer.style.display = 'flex';
    }
  }

  hideError() {
    if (this.errorContainer) {
      this.errorContainer.style.display = 'none';
    }
  }
}

// Initialize when DOM is ready (only if enabled in theme settings)
document.addEventListener('DOMContentLoaded', () => {
  if (window.edTryOnConfig && window.edTryOnConfig.enabled) {
    window.virtualTryOn = new VirtualTryOn();
  }
});
